import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { partition, some } from 'lodash'
import { push } from '@lagunovsky/redux-react-router'
import SmallPicturePanel from '../../../components/picture/SmallPicturePanel'
import FilePanel from '../../../components/file/FilePanel'
import { PICTURES_EXTENSIONS } from '../../../components/file/constant/FileConstants'
import RpqsAction from '../../actions/RpqsAction'
import { getRpqsDocumentsPath } from '../../utils/RPQSUtils'

// Photos + documents du RPQS (sans egId : RPQS global et toutes ses entités de gestion).
const RpqsFilesPanel = ({
    year,
    collectivityId,
    egId,
}) => {
    const dispatch = useDispatch()
    const [files, setFiles] = useState([])

    useEffect(() => {
        dispatch(RpqsAction.fetchDocuments(getRpqsDocumentsPath(year, collectivityId, egId))).then(res => setFiles(res ?? []))
    }, [dispatch, year, collectivityId, egId])

    const [pictures, documents] = partition(files, f => some(PICTURES_EXTENSIONS, extension => f.name.endsWith(extension)))
    const documentsPath = egId ? `/rpqs/${year}/collectivite/${collectivityId}/eg/${egId}/documents` : `/rpqs/${year}/collectivite/${collectivityId}/documents`

    return (
        <>
            {!!pictures.length && (
                <SmallPicturePanel pictures={pictures} />
            )}
            {!!documents.length && (
                <FilePanel files={documents} hideTitle onShowMore={() => dispatch(push(documentsPath))} />
            )}
        </>
    )
}

RpqsFilesPanel.propTypes = {
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    collectivityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    egId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default RpqsFilesPanel
